function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.476 10.772L13.198.451c-.6-.601-1.797-.601-2.396 0L.524 10.772c-.699.702-.699 1.704 0 2.405L10.802 23.5c.3.3.799.501 1.198.501.4 0 .898-.2 1.198-.501l10.278-10.322c.699-.701.699-1.703 0-2.405zM12 19.892l-7.884-7.917L12 4.058l7.884 7.917L12 19.89z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;